/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_UrlInputs */

const en_profile_avatar_url = /** @type {(inputs: Profile_Avatar_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar URL`)
};

const pt_br2_profile_avatar_url = /** @type {(inputs: Profile_Avatar_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do avatar`)
};

/**
* | output |
* | --- |
* | "Avatar URL" |
*
* @param {Profile_Avatar_UrlInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_avatar_url = /** @type {((inputs?: Profile_Avatar_UrlInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_UrlInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_avatar_url(inputs)
	return pt_br2_profile_avatar_url(inputs)
});